import React from "react"
import Helmet from "react-helmet"
import ContactUs from "@tightrope/footerlinks/contact-us"
import HomepageLayout from "src/layouts/homepage"
import JSONData from "branding/site-metadata.json"

export default function Contact() {
  return(

<HomepageLayout>
    <Helmet data={JSONData}><title>Contact Us</title></Helmet>
    <style type="text/css">{`
    .rawfooter-module--pageWrapper {
      width: 100% !important;
      margin:0;
    }
      .rawfooter-module--pageWrapper > div {
          min-height: 100vh;
          width: 96%;
          margin:0 auto;
    }

    .rawfooter-module--rawfooter {
      position: relative !important;
      width: 100% !important;
    }
    .rawfooter-module--siteLogo {
      margin:20px 3% 20px 3%;
    }
 
    `}
    </style>
    <ContactUs data={JSONData}></ContactUs>
</HomepageLayout>
  )
}
